import React from 'react';
import { Button } from 'reactstrap';
import { useNotification } from '../../services/notification';

const CopyButton = ({ id, copyValue, notificationMessage }) => {
    const notification = useNotification();
    return (<>
        <Button
            color="primary"
            size="sm"
            className="p-1"
            style={{ fontSize: "0.7rem", lineHeight: 1 }}
            title="Copy to clipboard"
            onClick={() => {
                navigator.clipboard.writeText(copyValue);
                notification.info(notificationMessage);
            }
            }>
            <i className="fas fa-copy"></i></Button>
    </>
    );
}

export default CopyButton;